<template>
    <form @submit.prevent="submitForm">
        <ValidationObserver v-slot="{ invalid, errors }">

            <ValidationProvider :name="$t('register.name')" rules="required" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">{{ $t('register.name') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="user"></icon>
                        </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.name"
                            class="form-control"
                            id="input-name"
                            :placeholder="$t('register.fill_in_name')"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('register.company_name')" rules="required" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">{{ $t('register.company_name') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="building"></icon>
                        </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.company_name"
                            class="form-control"
                            id="input-name"
                            :placeholder="$t('register.fill_in_company_name')"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('register.email')" rules="required|email" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-name" class="form-control-label">{{ $t('register.email') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <icon name="inbox"></icon>
                        </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.email"
                            class="form-control"
                            id="input-email"
                            :placeholder="$t('register.fill_in_email')"
                            :class="{ 'is-invalid': errors.length }"
                            required />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('register.telephone')" rules="" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group">
                    <label for="input-phone" class="form-control-label">{{ $t('register.telephone') }}</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="phone"></icon>
                            </span>
                        </div>
                        <input
                            type="text"
                            v-model="formValues.phone"
                            class="form-control"
                            id="input-phone"
                            :placeholder="$t('register.fill_in_telephone')"
                        />
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

            <ValidationProvider :name="$t('register.password')" rules="required" v-slot="{ errors }" class="flex-grow-1">
                <div class="form-group mb-0">
                    <label for="input-password" class="form-control-label">{{ $t('register.password') }} *</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <icon name="key"></icon>
                            </span>
                        </div>
                        <input
                            :type="passwordVisible ? 'text' : 'password'"
                            v-model="formValues.password"
                            class="form-control"
                            id="input-password"
                            :placeholder="$t('register.fill_in_password')"
                            :class="{ 'is-invalid': errors.length }"
                            required
                        />
                        <div class="input-group-append">
                                <span class="input-group-text" @click="togglePassword" style="cursor: pointer;">
                                    <icon :name="passwordVisible ? 'eye-slash' : 'eye'" style="fill: black !important;"></icon>
                                </span>
                        </div>
                        <div v-if="errors.length" class="invalid-feedback">{{ errors[0] }}</div>
                    </div>
                </div>
            </ValidationProvider>

        </ValidationObserver>
    </form>
</template>

<script>

    import { ValidationProvider, ValidationObserver } from 'vee-validate';

    export default {
        name: 'RegisterForm',

        components: {
            ValidationObserver,
            ValidationProvider,
        },

        data() {
            return {
                formValues: {
                    name: '',
                    company_name: '',
                    email: '',
                    phone: '',
                    password: '',
                },
                passwordVisible: false,
            };
        },
        methods: {
            togglePassword() {
                this.passwordVisible = !this.passwordVisible;
            },
            submitForm() {
                this.$emit('submit', this.formValues);
            },
        },
    };
</script>
